<template>
    <v-form
        ref="form"
        v-model="valid"
        class="reset-form"
        lazy-validation>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.code"
                        :rules="codeRules"
                        name="code"
                        autocomplete="new-password"
                        prepend-inner-icon="mdi-email-outline"
                        label="Code" />
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.password"
                        :rules="passwordRules"
                        name="new-password"
                        autocomplete="new-password"
                        prepend-inner-icon="mdi-lock-outline"
                        label="New password"
                        :type="showNewPassword ? 'text' : 'password'">
                        <template v-slot:append>
                            <v-btn
                                icon
                                @click="showNewPassword = !showNewPassword">
                                <v-icon>{{ showNewPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.confirmPassword"
                        :rules="confirmPasswordRules"
                        prepend-inner-icon="mdi-lock-outline"
                        name="confirm-password"
                        autocomplete="new-password"
                        label="Confirm password"
                        :type="showConfirmPassword ? 'text' : 'password'">
                        <template v-slot:append>
                            <v-btn
                                icon
                                @click="showConfirmPassword = !showConfirmPassword">
                                <v-icon>{{ showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0">
                    <v-row>
                        <v-col
                            v-for="(hint, i) in passwordHints"
                            :key="i"
                            cols="6"
                            class="py-0 text-left">
                            <span class="text-small">
                                <v-icon
                                    class="mr-1"
                                    :color="hint.status ? 'success' : 'error'">
                                    {{ hint.status ? 'mdi-check' : 'mdi-close' }}
                                </v-icon>

                                {{ hint.text }}
                            </span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row
                justify="center"
                class="mt-5">
                <v-col cols="12">
                    <v-btn
                        color="primary"
                        tile
                        @click="onSubmit">
                        reset password
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import { validators } from '@/utils/validators';

export default {
    name: 'ResetPasswordConfirmForm',

    data() {
        return {
            valid: true,
            codeRules: [(v) => validators.required(v, 'Code')],
            passwordRules: [(v) => validators.required(v, 'Password'), (v) => validators.minLength(v, 10)],
            confirmPasswordRules: [
                (v) => validators.required(v, 'Password'),
                (v) => {
                    return v === this.formData.password || "Passwords don't match";
                },
            ],
            showNewPassword: false,
            showConfirmPassword: false,
            formData: {
                code: null,
                password: null,
                confirmPassword: null,
            },
        };
    },

    computed: {
        passwordHints() {
            return [
                {
                    status: this.formData.password && this.formData.password.match(/[A-Z]/),
                    text: 'Include at least 1 uppercase letter',
                },
                {
                    status: this.formData.password && this.formData.password.match(/[a-z]/),
                    text: 'Include at least 1 lower case letter',
                },
                {
                    status: this.formData.password && this.formData.password.match(/[0-9]/),
                    text: 'Include at least 1 number',
                },
            ];
        },
    },

    beforeDestroy() {
        this.$store.commit('codeSent', false);
    },

    methods: {
        async onSubmit() {
            await this.$refs.form.validate();

            if (this.valid && this.passwordHints.every((hint) => hint.status)) {
                this.$emit('submit', {
                    code: this.formData.code,
                    password: this.formData.password,
                });
            }
        },
    },
};
</script>

<style></style>